module.exports = __webpack_public_path__ + "static/media/npm.21107776.svg";